import React, { useState, useEffect, useRef } from 'react'
import { excel2JsonCutSubHead } from '../../../utils/XlsxUtil'
import axios from '../../../utils/AxiosUtil'
import { billCols, validColumn, MAX_SUBMIT_BILL_NUM, projRmkCol } from '../../../constants/billConstants'
import { FGLOBAL } from '../../../constants/frontGlobal'

import { EditableProTable } from '@ant-design/pro-table';
import { Tooltip, Input, Switch, Upload, Button, Modal, Select, Space, Form } from 'antd';
import './add-bill.less'

import { getDataResourceWithValid, getRecordWithValid } from './billHelper'
import { upSertAxios, mask, unmask } from '../../../components/reqAndHint'
import { RollbackOutlined, UndoOutlined, SearchOutlined } from '@ant-design/icons';
import { getDeleteCheckedRows } from '../../../components/table/batchDelFunc'
import { useSelector, useDispatch } from 'react-redux'
import { projectChange } from '../../../reducers/projectReducers'
const { Option } = Select;


// 票据列表-编辑
export default function UpdateBill(props) {
    console.log('*****props:', props);
    const volunList = useSelector(state => state.volunList.value)
    let [uform] = Form.useForm();
    const dispatch = useDispatch()
    const langValue = useSelector(state => state.langList.value)
    const projectList = useSelector(state => state.projectList.value)
    const [editableKeys, setEditableRowKeys] = useState([]);//正在编辑状态的行
    const [dataSource, setDataSource] = useState([]);
    const columns = [...billCols];
    const [fileIsLoading, setFileIsLoading] = useState(false);
    const [selectedRowKeysArr, setSelectedRowkeysArr] = useState([]);
    const [areas, setAreas] = useState(null);
    const [choosenArea, SetChoosenArea] = useState('');
    const [rslctValue, setRslctValue] = useState(false);
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [rawData, setRawData] = useState();
    const { Search } = Input;
    const [hasMin, setHasMin] = useState(false);
    const [amount, setAmount] = useState(0);

    const [projectArr, setProjectArr] = useState([]); // 用途的选择框

    let isFinance = FGLOBAL.get('roleId') && +FGLOBAL.get('roleId') < 4;//财务工作人员

    if (FGLOBAL.get('roleId') && +FGLOBAL.get('roleId') < 4) {
        //地区财务窗口以外人员 表头额外字段
        columns.push(projRmkCol);
    }


    const handleSearch = (value) => {

        //有rawDate则说明是多次搜索
        if (rawData) {
            //有搜索关键词且当前数据和原数据相同，正常过滤
            if (rawData == dataSource && value) {
                // console.log('多次search');
                setRawData(dataSource);
                mask();
                let newData = dataSource.filter(d => d['开立票据名称'].includes(value));
                // console.log('after filter:', newData);
                setDataSource(newData);
                unmask();
                //无关键词，且过滤后和原数据不同，返回原数据
            } else {
                // console.log('多次取消search');
                setDataSource(rawData);
            }

            //没有rowData,说明是第一次搜索
        } else {
            //有关键词，则正常过滤筛选
            if (value) {
                // console.log('第一次search');
                setRawData(dataSource);
                mask();
                let newData = dataSource.filter(d => d['开立票据名称'].includes(value));
                // console.log('after filter:', newData);
                setDataSource(newData);
                unmask();
                //没有值，无反应
            } else {
                // console.log('第一次取消search');
            }
        }

    }

    columns[1].title =
        (<div id='billq-scth'>
            <span>{langValue == 0 ? '开立票据名称Receipt Title' : (langValue == 1 ? '开立票据名称' : 'Receipt Title')}</span>

            <span>
                <Tooltip title={showSearchBar ? '点击收起搜索' : '点击展开搜索'}>
                    <SearchOutlined
                        onClick={() => {
                            // console.log('search:', showSearchBar);
                            if (showSearchBar) {
                                //有rawData则说明是多次筛选
                                if (rawData) {
                                    //rawData和当前数据相同,直接关闭
                                    if (rawData == dataSource) {
                                        // console.log('close search');
                                        //重新生成序号
                                        dataSource.forEach((d, i) => {
                                            d['序号'] = i + 1;
                                        })
                                        setDataSource(dataSource);
                                        setRawData(undefined);

                                        //rawData和当前数据不同,返回原数据
                                    } else {
                                        // console.log('reset and close search');
                                        // console.log('rawdata:', rawData ?.length);
                                        // console.log('data:', dataSource ?.length);
                                        //重新生成序号
                                        rawData.forEach((d, i) => {
                                            d['序号'] = i + 1;
                                        })
                                        setDataSource(rawData);
                                        setRawData(undefined);
                                    }

                                    //没有rawData,说明是第一次筛选,直接关闭
                                } else {
                                    // console.log('no raw,close search');
                                    //重新生成序号
                                    dataSource.forEach((d, i) => {
                                        d['序号'] = i + 1;
                                    })
                                    setDataSource(dataSource);
                                }

                            } else {
                                // console.log('open search');
                            }
                            setShowSearchBar(!showSearchBar)
                        }}
                        style={{ fontSize: '20px', fontWeight: '1000', border: '1px solid blue', color: 'blue', position: 'relative', left: '5px', top: '2px' }} />
                </Tooltip >
            </span>
            <Search
                placeholder={langValue == 0 ? '输入关键字Enter Keyword' : (langValue == 1 ? '输入关键字' : 'Enter Keyword')}
                allowClear
                enterButton
                onSearch={handleSearch}
                style={{ display: showSearchBar ? 'block' : 'none' }}
            />
        </div>);
    columns[1].width = '10rem';


    useEffect(() => {

        // getUserProject();

        (async function () {
            SetChoosenArea(props.recordArea);
            //获取用户地区（+时间）信息，若无数据，提示
            mask();
            let areaData = await axios.post('/fund/area/area-by-uid', { uid: sessionStorage.getItem('uid') }, { timeout: 30000 })
                .then(data => {
                    unmask();
                    // console.log('获取用户地区信息data:', data, data ?.data ?.userArea);
                    let areas = data ?.data ?.userArea ?.map(area => {
                        return { areaId: area.aid, areaName: area.key }
                    });

                    if (!areas || !areas.length) {
                        Modal.error({ title: '待处理：', content: "当前用户未关联地区，请联系财务同仁修改" });
                        return null;
                    } else {
                        return areas;
                    }
                })
                .catch(e => {
                    unmask();
                    // console.log('获取用户信息错误：', e);
                    Modal.error({ title: '待处理：', content: "获取用户信息时出错：" + e });
                    return null;
                })
            if (areaData) {
                setAreas(areaData);
            }

            // console.log('recordId:', props.recordId);
            mask();
            // 获取用途数组 验证用途字段
            // console.log('bill update getuserProject');
            // console.log(projectList);
            if (projectList.length < 1) {
                let data = await axios.post('/fund/project/getUserProject', { role_id: FGLOBAL.get('roleId') });
                let projectArr = []
                data.data.forEach(item => {
                    var obj = {
                        ch_pro: item,
                        en_pro: item
                    }
                    projectArr.push(obj)

                })
                dispatch(projectChange({ value: projectArr }))
                setProjectArr(projectArr);
            } else {
                setProjectArr(projectList)
            }
            axios.post('/fund/bill/getBillRecordTempById', { recordId: props.recordId }, { timeout: 30000 })
                .then(data => {
                    unmask();
                    // console.log('编辑票据明细data:', data);
                    //总金额
                    let totalAmount = 0;
                    let hasMin = false;//金额中有负数
                    let dtSrc = [...data.data.data.bill_detail];
                    dtSrc.forEach((d, i) => {
                        d['序号'] = i + 1;
                        if (+d['金额'] < 0) {
                            hasMin = true;
                        }
                        let amt = Number(d['金额']);
                        totalAmount = Number(amt.toFixed(2)) + Number(totalAmount.toFixed(2));
                        totalAmount = Number(totalAmount.toFixed(2));
                    });

                    setDataSource(getDataResourceWithValid(dtSrc, projectList));
                    setHasMin(hasMin);
                    setAmount(totalAmount);
                })
                .catch(e => {
                    unmask();
                    // console.log('编辑票据明细错误：', e);
                })
        })()

    }, [])

    //表格选择框
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedRowkeysArr([...selectedRowKeys]);
        },
        // getCheckboxProps: (record) => ({
        //   disabled: record.name === 'Disabled User',
        //   // Column configuration not to be checked
        //   name: record.name,
        // }),
    };


    // 根据用户权限获取用途
    const getUserProject = async () => {
        // console.log('bill update guproject2')
        if (projectList.length < 1) {
            let data = await axios.post('/fund/project/getUserProject', { role_id: FGLOBAL.get('roleId') });
            let projectArr = []
            data.data.forEach(item => {
                var obj = {
                    ch_pro: item,
                    en_pro: item
                }
                projectArr.push(obj)

            })
            dispatch(projectChange({ value: projectArr }))
            setProjectArr(projectArr);
        } else {
            setProjectArr(projectList)
        }
    }


    const getColumns = (col) => {

        // let projectValueEnum = {}
        // projectArr ?.forEach(p => {
        //     let value = { text: p }
        //     projectValueEnum[p] = value;
        // });

        // 设置用途字段的下拉选项 
        // col[5].valueEnum = projectValueEnum;

        // 用途提示
        // let projectStr = '';
        // for (var key in projectValueEnum) {
        //     projectStr += ' "' + key + '" ';
        // }

        col.forEach((item, i) => {
            if (i != 0 && i != 5) {
                item.renderFormItem = () => {
                    return <Input
                        type="text"
                        size="small"
                        style={{ height: '30px' }}
                        placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')}
                    />
                }
            }
            if (item.dataIndex == '开立票据名称') {
                item.formItemProps = () => {
                    return {
                        rules: [
                            { required: true, message: langValue == 0 ? '必填Required' : (langValue == 1 ? '必填' : 'Required') },
                            { pattern: /^((?![&/\\]).)*$/, message: langValue == 0 ? <>不能包含 & / \\ ，请检查！<br />Cannot contain & / \\, please check!</> : (langValue == 1 ? '不能包含 & / \\ ，请检查！' : 'Cannot contain & / \\, please check!') },
                        ],
                    };
                }
            }
            else if (item.dataIndex == '身份证号') {
                item.formItemProps = () => {
                    return {
                        rules: [
                            { pattern: /^\w{0,18}$/, message: langValue == 0 ? <>不能超过18位<br />Cannot exceed 18 digits</> : (langValue == 1 ? '不能超过18位' : 'Cannot exceed 18 digits') }
                        ],
                    };
                }
            }
            // else if (item.dataIndex == 'TIN') {
            //     item.formItemProps = () => {
            //         return {
            //             rules: [
            //                 { pattern: /^\w{18}$/, message: langValue == 0 ? <>固定18位，或不填<br />Fixed 18 digits, or empty</> : (langValue == 1 ? '固定18位，或不填' : 'Fixed 18 digits, or empty') },
            //             ],
            //         };
            //     }
            // }
            else if (item.dataIndex == '用途') {
                // 渲染用途字段的验证提示
                item.render = (text, record) => {
                    let purposeStr = record['用途'];

                    const arr = projectArr.filter(item => text ?.includes(item ?.ch_pro));

                    let valid = record.purposeValid;
                    // 校验：必填
                    return !valid ? (
                        <Tooltip title={'不存在该项目！'} trigger="hover">
                            <div style={{ color: 'red' }}>
                                {(purposeStr == 'undefined' || !purposeStr) ? '未填' : purposeStr}
                            </div>
                        </Tooltip>
                    ) : (<>{arr[0] ?.ch_pro}</>);
                }
                // 渲染用途组件
                item.renderFormItem = (_, { isEditable }) => {
                    return (
                        <Select
                            placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
                            showSearch
                        >
                            {projectArr ?.map((item2, index) => {
                                return <Option key={index} value={item2 ?.ch_pro}>{item2 ?.ch_pro}</Option>
                            })}
                        </Select>
                    )
                }
            }
            else if (item.dataIndex == '志工编号') {
                // 渲染志工编号组件
                item.renderFormItem = (_, record) => {
                    return (
                        <Select
                            placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
                            showSearch
                            onChange={(value) => {
                                console.log('value:', value);
                                console.log('record:', record);
                                // 查找选中的编号对应的志工姓名
                                const selectedVolunteer = volunList.find(v => v.volunteer_code === value);
                                let fv = {
                                    [`${record.recordKey}`]: {
                                        '志工编号': value,
                                        '志工姓名': selectedVolunteer ? selectedVolunteer.volunteer_name : '',
                                        '志工英文名': selectedVolunteer ? selectedVolunteer.vol_en_name : '',
                                    },
                                };
                                console.log('fv:', fv)
                                // // 更新当前行的志工编号和志工姓名
                                record['志工英文名'] = selectedVolunteer ?.vol_en_name;
                                record['志工姓名'] = selectedVolunteer ?.volunteer_name;
                                uform.setFieldsValue(fv);
                            }
                            }
                        >
                            {volunList ?.map((item2, index) => {
                                return <Option key={index} value={item2 ?.volunteer_code}>{item2 ?.volunteer_code}</Option>
                            })}
                        </Select>
                    )
                }
            }
            // @tmpmdel
            // else if(item.dataIndex=='非陆籍填1'){
            //     // 渲染选择组件
            //     item.renderFormItem = (_, { isEditable })=>{
            //         return (
            //             <Select
            //             placeholder={langValue==0?'请选择(Please select)':(langValue==1?'请选择':'Please select')}
            //             showSearch
            //             options={[{label:'1',value:'1'},{label:' ',value:''}]}
            //             >
            //             </Select>
            //         )
            //     }
            // }
            // else if(item.dataIndex=='法人填1，自然人不填'){
            //     // 渲染选择组件
            //     item.renderFormItem = (_, { isEditable })=>{
            //         return (
            //             <Select
            //             placeholder={langValue==0?'请选择(Please select)':(langValue==1?'请选择':'Please select')}
            //             showSearch
            //             options={[{label:'1',value:'1'},{label:' ',value:''}]}
            //             >
            //             </Select>
            //         )
            //     }
            // }
        })
        let operCol = {
            title: '操作',
            en_title: 'Operation',
            ch_title: '操作',
            valueType: 'option',
            width: '90px',
            render: (text, record, _, action) => [
                <a
                    key="editable"
                    onClick={() => {
                        // console.log("text:", text, record, action);
                        // console.log("record:", record);//行数据的JSON obj
                        // console.log("action:", action);
                        action ?.startEditable ?.(record['序号']);
                    }}
                >
                    {langValue == 0 ? '编辑Edit' : (langValue == 1 ? '编辑' : 'Edit')}
                </a>
            ],
        };
        let newCol = [...col];
        newCol.push(operCol);

        // ***列render时验证列并按需高亮
        newCol.push(validColumn);
        // 中英切换
        newCol.forEach((item, i) => {
            if (i == newCol.length - 1) {
                item.render = (text, record, index) => {
                    // console.log(record);
                    //整行的验证状态
                    return !record.rcdValid ? (<font color='red'>{langValue == 0 ? <>异常<br />Not Active</> : (langValue == 1 ? '异常' : 'Not Active')}</font>) : (langValue == 0 ? <>正常<br />Active</> : (langValue == 1 ? '正常' : 'Active'));
                }
            }
            if (item.title == '邮箱') return
            if (i != 1) {
                item.title = langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)
            }

        })
        return newCol;
    }

    let d = new Date();
    let date = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();

    const selectArea = (value) => {
        // console.log('selectArea:', value);
        SetChoosenArea(value);
    }

    /**
     * 
     * @param callBack 验证成功的回调
     * @param action '提交'或'暂存'
     */
    function validData(callBack, action) {

        //先关闭搜索框再操作后续
        if (showSearchBar) {
            // console.log('取消筛选');
            Modal.error({
                title: '请关闭筛选后继续操作！'
            });
            return;
        }

        //1.拦截数据为空或超限
        if (!dataSource ?.length) {
            Modal.error({
                title: langValue == 0 ? '待处理Pending processing' : (langValue == 1 ? '待处理' : 'Pending processing'),
                content: langValue == 0 ? <>请先添加数据<br />Please add data first</> : (langValue == 1 ? '请先添加数据' : 'Please add data first'),
                okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
            });
            return;
        } else if (dataSource.length > MAX_SUBMIT_BILL_NUM) {
            var str = "一次最多上传" + MAX_SUBMIT_BILL_NUM + "条，当前条数 " + dataSource.length + " ,请分批提交"
            var enstr = "Upload a maximum of " + MAX_SUBMIT_BILL_NUM + "items at once，Current number of items " + dataSource.length + " ,Please submit in batches"
            Modal.error({
                title: langValue == 0 ? '超过最大限制条数Exceeding the maximum limit of entries' : (langValue == 1 ? '超过最大限制条数' : 'Exceeding the maximum limit of entries'),
                content: langValue == 0 ? <>{str}<br />{enstr}</> : (langValue == 1 ? str : enstr),
                okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
            });
            return;
        }
        //2.编辑行未保存
        if (editableKeys[0]) {
            var str = '序号为' + editableKeys[0] + '的数据正在编辑，请先保存该行'
            var enstr = 'The data with serial number' + editableKeys[0] + 'is currently being edited. Please save the row first'
            Modal.error({
                title: langValue == 0 ? '请先保存Please save first' : (langValue == 1 ? '请先保存' : 'Please save first'),
                content: langValue == 0 ? <>{str}<br />{enstr}</> : (langValue == 1 ? str : enstr),
                okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
            });
            return;
        }
        //3.数据格式（rule）校验
        //console.log('submit onClick，datasource*:', dataSource, "datasource str:", JSON.stringify(dataSource));
        let tableValid = true;
        for (let i = 0; i < dataSource.length; i++) {
            // console.log(dataSource[i]);
            if (dataSource[i] ?.rcdValid === false) {
                tableValid = false;
                break;
            }
        }
        if (action != "暂存" && tableValid === false) {
            Modal.error({
                content: (
                    <div>
                        <h2>{langValue == 0 ? <>有数据验证未通过，请点击校验筛选出异常数据并修改<br />Data validation did not pass. Please click on the verification to filter out abnormal data and make modifications</> : (langValue == 1 ? '有数据验证未通过，请点击校验筛选出异常数据并修改' : 'Data validation did not pass. Please click on the verification to filter out abnormal data and make modifications')}。</h2>
                    </div>
                ),
                okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
            });
            return;
        }

        //4.提交前多一次确认
        if (action == '提交') {
            Modal.confirm({
                title: langValue == 0 ? '提交后将无法修改Once submitted, it cannot be modified' : (langValue == 1 ? '提交后将无法修改' : 'Once submitted, it cannot be modified'), content: <div style={{ fontSize: 20 }}>
                    <div>{langValue == 0 ? '当前总金额(Current total amount)：' : (langValue == 1 ? '当前总金额：' : 'Current total amount：')}{amount}</div>
                    <div>{langValue == 0 ? <>数据将发送给财务，并无法修改。确认提交？<br />The data will be sent to the finance department and cannot be modified. Confirm submission?</> : (langValue == 1 ? '数据将发送给财务，并无法修改。确认提交？' : 'The data will be sent to the finance department and cannot be modified. Confirm submission?')}</div>
                </div>,
                okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
                onOk: () => {
                    confirmArea();
                }
            });
        } else {
            //暂存则不需要
            confirmArea();
        }

        function confirmArea() {
            if (!choosenArea) {
                Modal.error({ content: langValue == 0 ? <>请先选择地区<br />Please select the region first</> : (langValue == 1 ? '请先选择地区' : 'Please select the region first'), okText: langValue == 0 ? '知道了Yes' : (langValue == 1 ? '知道了' : 'Yes') });
                return;
            } else {
                let areaName = choosenArea.split('-')[0];
                Modal.confirm({
                    title: langValue == 0 ? '地区确认Confirm Region：' : (langValue == 1 ? '地区确认：' : 'Confirm Region：'),
                    content: (
                        <div>
                            <p>{langValue == 0 ? '请确认您上传的记录都属于Please confirm that all the records you uploaded belong to' : (langValue == 1 ? '请确认您上传的记录都属于' : 'Please confirm that all the records you uploaded belong to')}:</p>
                            <p><b>{'     ' + areaName}</b></p>
                        </div>),
                    okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
                    cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
                    onOk: () => {
                        if (typeof callBack == 'function') {
                            callBack(action);
                        }
                    },
                    onCancel: () => {
                        return;
                    }
                });
            }
        }

    }

    //发送表格数据到后台
    function sendTableData(action) {
        let url;
        if (action == '暂存') {
            url = '/bill/updateTemp';
        } else if (action == '提交') {
            url = '/bill/updateTemp2Sub';
        }


        upSertAxios(url, { billDetail: dataSource, area: choosenArea, recordId: props.recordId, uid: sessionStorage.getItem('uid') },
            (data) => {
                // console.log('billDetail upSert成功');
                props.setModalVisible(false);
                props.reloadRecordList();
            },
            (e) => {

                //回调显示弹窗 列出所有错误
                if (e ?.response ?.data ?.hint) {
                    let hint = e.response.data.hint;
                    // console.log('record upSert失败', e?.response?.data?.hint);
                    Modal.destroyAll();
                    Modal.error({
                        width: '50%',
                        title: langValue == 0 ? '错误如下The error is as follows:' : (langValue == 0 ? '错误如下:' : 'The error is as follows:'),
                        centered: true,
                        content: (
                            <div style={{ textAlign: 'left', marginLeft: 48, fontSize: 16 }}>
                                {hint && hint.length > 0 && hint.map((h, i) => {
                                    return (<div key={i} style={{ marginTop: 7, marginBottom: 7 }}>{(i + 1) + '. '}{langValue == 0 ? <>{h.hint}<br />{h.en_hint}</> : (langValue == 1 ? h.hint : h.en_hint)}</div>)
                                })}
                            </div>
                        )
                        ,
                        okText: langValue == 0 ? '知道了Yes' : (langValue == 1 ? '知道了' : 'Yes')
                    });

                }

            },
            60000
        );

    }

    const deleteCheckedRows = (onCleanSelected) => {
        // console.log('deleteCheckedRows:');
        //有筛选数据，则需要修改rawData
        var data;
        if (rawData) {
            data = dataSource;
            getDeleteCheckedRows(onCleanSelected, editableKeys, selectedRowKeysArr, data, rawData, setDataSource, setRawData)();

        } else {
            data = dataSource;
            getDeleteCheckedRows(onCleanSelected, editableKeys, selectedRowKeysArr, data, null, setDataSource, null)();
        }

        // console.log('rawdata:', rawData?.length);
        // rawData?.forEach(rd => {
        //     console.log('序号：', rd['序号']);
        // });

        // console.log('data:', dataSource?.length);
        // dataSource?.forEach(rd => {
        //     console.log('序号：', rd['序号']);
        // });

    }

    const handleUpload = async (file) => {

        mask();
        // console.log('编辑票据列表，一键上传的文件:', file);
        let type = 'tableA'

        // let json = await excel2Json(file, type, isFinance);
        let json = await excel2JsonCutSubHead(file, type, isFinance);
        // console.log('importExcel xlsx2json:', json);
        // console.log('importExcel json str:', JSON.stringify(json));

        if (json.title) {
            Modal.error({
                title: json.title,
                content: json.content
            })
            unmask();
            return
        }

        let arr = [...dataSource, ...json];

        //排序
        arr = volunteerSort(arr);
        //重算总额
        let totalAmount = 0;
        arr.forEach((d, i) => {
            let amt = Number(d['金额']);
            totalAmount = Number(amt.toFixed(2)) + Number(totalAmount.toFixed(2));
            totalAmount = Number(totalAmount.toFixed(2));
        });
        setAmount(totalAmount);

        arr = getDataResourceWithValid(arr, projectArr);
        //更新表格数据
        setDataSource(arr);
        unmask();
        return false;
    }

    //志工编号升序排序逻辑
    const volunteerSort = (arr) => {
        //过滤带诚的委员 并丢入一个数组
        let chengVArr = []
        arr = arr.filter((a) => {
            a.志工编号 = String(a.志工编号)
            if (a.志工编号.includes('诚')) {
                chengVArr.push(a)
            }
            return !a.志工编号.includes('诚')
        })

        //带诚的委员数组排序
        chengVArr.sort((a, b) => {
            a.志工编号 = String(a ?.志工编号)
            b.志工编号 = String(b ?.志工编号)
            //过滤编号中的诚，再比较大小
            let aCode = a.志工编号.replace('诚', '')
            let bCode = b.志工编号.replace('诚', '')
            // console.log(a?.志工编号, b?.志工编号);
            let aArr = aCode.split('-');
            let bArr = bCode.split('-');
            // console.log(aArr, bArr);
            //按志工编号升序，处理xxx-9比xxx-10大的特殊情况
            if (aArr[0] == bArr[0]) {
                //编号没有-，比较结果为NaN，需要赋值0 用于比较大小
                if (!aArr[1]) aArr[1] = 0
                if (!bArr[1]) bArr[1] = 0
                return aArr[1] - bArr[1];
            } else {
                return aArr[0] - bArr[0];
            }
        })
        // console.log('chengVArr:', chengVArr);

        //志工编号排序
        arr.sort((a, b) => {
            a.志工编号 = String(a ?.志工编号)
            b.志工编号 = String(b ?.志工编号)
            // console.log(a?.志工编号, b?.志工编号);
            let aArr = a ?.志工编号 ?.split('-');
            let bArr = b ?.志工编号 ?.split('-');
            // console.log(aArr, bArr);
            //按志工编号升序，处理xxx-9比xxx-10大的特殊情况
            if (aArr[0] == bArr[0]) {
                if (!aArr[1]) aArr[1] = 0
                if (!bArr[1]) bArr[1] = 0
                return aArr[1] - bArr[1];
            } else {
                return aArr[0] - bArr[0];
            }
        })
        //数组合并 带诚的委员放在最后
        arr = [...arr, ...chengVArr]

        return arr;
    }
    let Batchstr
    if (langValue == 0) {
        Batchstr = (
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 'normal' }}>
                <span>{'批量删除' + (!!rslctValue ? '(开)' : '(关)')}</span>
                <span>{'Batch Deletion' + (!!rslctValue ? '(on)' : '(off)')}</span>
            </div>
        )
    } else if (langValue == 1) {
        Batchstr = (
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 'normal' }}>
                <span>{'批量删除' + (!!rslctValue ? '(开)' : '(关)')}</span>
            </div>
        )
    } else {
        Batchstr = (
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 'normal' }}>
                <span>{'Batch Deletion' + (!!rslctValue ? '(on)' : '(off)')}</span>
            </div>
        )
    }

    return (
        <div className="add-bill" id="add-bill">
            <div className='add-bill-nav'>
                <span className='content'>{langValue == 0 ? '票据列表(Ticket List)' : (langValue == 1 ? '票据列表' : 'Ticket List')}{'>'}{langValue == 0 ? '编辑(Edit)' : (langValue == 1 ? '编辑' : 'Edit')}</span>
                <Button className='back-button' type='link'
                    onClick={() => { props.setModalVisible(false) }}
                    icon={<UndoOutlined rotate="90" />}
                >
                    {/* <RollbackOutlined style={{ fontSize: '16px', fontWeight: '1900', color: '#08c' }} /> */}

                    {langValue == 0 ? '返回Return' : (langValue == 1 ? '返回' : 'Return')}
                </Button>
            </div>
            <div className="base-info">
                <h1 className="info-title">
                    {langValue == 0 ? '基础信息 Basic Information' : (langValue == 1 ? '基础信息' : 'Basic Information')}
                </h1>
                <div className='bi-content'>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '录入日期(Date of Entry )' : (langValue == 1 ? '录入日期' : 'Date of Entry ')}：</span>
                        <span>{props.recordDate}</span>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '地区(Region)' : (langValue == 1 ? '地区' : 'Region')}：</span>
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            onChange={selectArea}
                            loading={!areas}
                            placeholder={langValue == 0 ? '请选择地区(Please select region)：' : (langValue == 1 ? '请选择地区：' : 'Please select region:')}
                            defaultValue={props.recordArea}
                        >
                            {areas ?.map(area => {
                                return <Option key={area.areaName} value={area.areaName}>{area.areaName}</Option>
                            })}
                        </Select>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '当前总金额(Current Balance)' : (langValue == 1 ? '当前总金额' : 'Current Balance')}：</span>
                        <span>{amount}</span>
                    </div>
                    {/* <div className='bc-item'>
                        <span>志工人数：</span>
                        <span>{props.recordVolCnt}</span>
                    </div> */}
                    <div className="batch-wrapper">
                        {Batchstr}
                        <Switch checked={!!rslctValue} onChange={(checked) => {
                            if (checked) {
                                setRslctValue(rowSelection);
                            } else { setRslctValue(false) }
                        }} />
                    </div>
                </div>
            </div>
            <div className="bill-info">
                <div className="info-title">
                    <span>{langValue == 0 ? '票据信息 Ticket Information' : (langValue == 1 ? '票据信息' : 'Ticket Information')}</span>
                    {hasMin ? <span style={{ color: 'red', paddingLeft: '2.5rem' }}>提醒：有金额为负数</span> : null}
                    <Upload
                        beforeUpload={handleUpload}
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                        // showUploadList={{ showRemoveIcon: false }}
                        showUploadList={false}
                        maxCount={1}
                        disabled={showSearchBar ? true : false}
                    >
                        <div className='upload-wrapper'>
                            <Button type="primary" onClick={() => {
                                //提示追加导入需关闭搜索
                                if (showSearchBar) {
                                    Modal.error({
                                        title: '請關閉篩選後繼續操作！Please turn off filtering to continue'
                                    });
                                    return;
                                }
                            }}>{langValue == 0 ? '追加导入Add import' : (langValue == 1 ? '追加導入' : 'Add import')}</Button>
                        </div>
                    </Upload >
                </div>
                <div className='bill-table-container'>
                    <EditableProTable
                        sticky
                        rowKey="序号"//editableKeys
                        scroll={{
                            x: 960,
                        }}
                        recordCreatorProps={
                            {
                                position: 'bottom',
                                //空白时新增行，然后传文件；及传文件，新增行，key的处理。
                                record: () => ({ '序号': dataSource.length + 1 }),
                                type: 'primary',
                                style: {
                                    //关闭搜索时才能添加一行
                                    display: showSearchBar ? 'none' : '',
                                },
                                creatorButtonText: langValue == 0 ? '添加一行数据 Add a row of data' : (langValue == 1 ? '添加一行数据' : 'Add a row of data')
                            }
                        }
                        loading={false}
                        columnEmptyText=''//空值时不显示'-',显示空字符串

                        columns={getColumns(columns)}
                        tableAlertOptionRender={({ selectedRowKeys, selectedRows, onCleanSelected }) => {
                            return <Space size={24}>
                                <span>
                                    {selectedRowKeys.length ? (<Button style={{ marginLeft: 8 }} onClick={onCleanSelected}>
                                        {langValue == 0 ? '取消选择Unselected' : (langValue == 1 ? '取消选择' : 'Unselected')}
                                    </Button>) : null}
                                </span>
                                <Button type='primary' ghost
                                    onClick={() => { deleteCheckedRows(onCleanSelected) }}
                                >批量删除</Button>
                            </Space>
                        }}
                        value={dataSource}
                        onChange={
                            (dataSrc) => {
                                // console.log('epTable onChange:', dataSrc);
                                // console.log('rawdata:', rawData ?.length);
                                // console.log('data:', dataSource ?.length);

                                // 没有rawData时 重新编号,防止编辑更新时，重新排序
                                if (!rawData) {
                                    // console.log('没有rawData,重新生成序号');
                                    //重新生成序号
                                    dataSrc.forEach((d, i) => {
                                        d['序号'] = i + 1;
                                    })
                                }

                                setDataSource(dataSrc);
                            }
                        }
                        editable={{
                            type: 'single',//一次只编辑一行，else multiple
                            form: uform,
                            editableKeys: editableKeys,//使用（EditableProTable）rowKey 的配置
                            onlyOneLineEditorAlertMessage: '序号为' + editableKeys[0] + '的数据正在编辑，请先保存该行',
                            onSave: async (rowKey, data, row) => {
                                // console.log("onSave:", 'rowKey:', rowKey, 'data:', data, 'row:', row);
                                getRecordWithValid(data, projectArr);
                                // 若有筛选，保存当前dataSource的同时需要处理rawData
                                if (rawData) {
                                    console.log('rawData:', rawData);
                                    for (let i = 0; i < rawData.length; i++) {
                                        if (rawData[i]['序号'] == rowKey) {
                                            rawData[i] = data
                                        }
                                    }
                                    // console.log(rawData);
                                } else {
                                    console.log('onsave no rawData')
                                }
                                setAmount(amount + +data['金额'] - +row['金额']);
                                //重算总额
                                // let totalAmount = 0;
                                // dataSource.forEach((d, i) => {
                                //     let amt = Number(d['金额']);
                                //     totalAmount = Number(amt.toFixed(2)) + Number(totalAmount.toFixed(2));
                                //     totalAmount = Number(totalAmount.toFixed(2));
                                // });
                                // setAmount(totalAmount);
                                // await waitTime(100);
                            },
                            onDelete: async (rowKey, data, row) => {
                                // console.log("onDelete:", rowKey, data, row);
                                // console.log('rawdata:', rawData ?.length);
                                // console.log('data:', dataSource ?.length);
                                // console.log('onDelete rowKey:', rowKey);
                                //若有筛选，需处理rawData
                                if (rawData) {
                                    //
                                    if (rawData != dataSource) {
                                        // console.log('raw != data on delete');
                                        let ds = rawData.filter((d) => rowKey != d['序号']);//删除当前行
                                        // console.log('onDelete filter:', ds);
                                        //重排序号
                                        ds.forEach((d, i) => {
                                            d['序号'] = i + 1
                                        });
                                        setRawData([...ds]);

                                    } else {
                                        // console.log('raw == data on delete');
                                        let ds = rawData.filter((d) => rowKey != d['序号']);//删除当前行
                                        // console.log('onDelete filter:', ds);
                                        //这个分支重新排序会报错

                                        setRawData([...ds]);
                                    }
                                }
                                setAmount(amount - +data['金额']);//重算总金额
                                //重算总额
                                // let totalAmount = 0;
                                // dataSource.forEach((d, i) => {
                                //     let amt = Number(d['金额']);
                                //     totalAmount = Number(amt.toFixed(2)) + Number(totalAmount.toFixed(2));
                                //     totalAmount = Number(totalAmount.toFixed(2));
                                // });
                                // setAmount(totalAmount);
                            },
                            onChange: (editableKeys, editableRows) => {
                                // console.log("onchange editableKeys:", editableKeys, typeof editableKeys[0]);
                                // console.log("editableRows:", editableRows);
                                setEditableRowKeys(editableKeys);
                            },
                            actionRender: (row, config, defaultDom) => {
                                // console.log("actionRender:", row);
                                return selectedRowKeysArr.includes(row['序号']) ? [defaultDom.save, defaultDom.cancel] : [defaultDom.save, defaultDom.delete, defaultDom.cancel];
                            },
                            saveText: <span id="bill-saveText">{langValue == 0 ? '保存Save' : (langValue == 1 ? '保存' : 'Save')}</span>,
                            deleteText: <span id="bill-delText">{langValue == 0 ? '删除Delete' : (langValue == 1 ? '删除' : 'Delete')}</span>,
                            cancelText: <span id="bill-canText">{langValue == 0 ? '取消Cancel' : (langValue == 1 ? '取消' : 'Cancel')}</span>,

                        }}
                        pagination={{
                            pageSize: 10,
                            pageSizeOptions: [10, 20, 50, 100, 1000],
                            showQuickJumper: true,
                            showSizeChanger: true,//可选每页条数，数据少时仍展示
                        }}
                        bordered
                        // rowClassName={(record, index) => record.notValid ? 'warning' : ''}
                        rowSelection={rslctValue}
                    />
                    <Button
                        type="primary"
                        key="submit"
                        style={{ marginLeft: 24, marginBottom: 24 }}
                        onClick={() => {
                            // console.log('submit onClick,datasource*:', dataSource, "datasource str:", JSON.stringify(dataSource));
                            validData(sendTableData, '提交');
                        }}
                    >
                        {langValue == 0 ? '确定提交Confirm and Submit' : (langValue == 1 ? '确定提交' : 'Confirm and Submit')}
                    </Button>
                    <Button
                        type="ghost"
                        key="temp"
                        style={{ marginLeft: '10px' }}
                        onClick={() => {
                            // console.log('temp onClick，datasource*:', dataSource, "datasource str:", JSON.stringify(dataSource));
                            validData(sendTableData, '暂存');
                        }}
                    >
                        {langValue == 0 ? '暂存Save temporarily' : (langValue == 1 ? '暂存' : 'Save temporarily')}
                    </Button>
                    <Button className='back-button-bottom' type='link' style={{ position: 'absolute', right: '20px', fontWeight: '600', fontSize: '16px' }}
                        onClick={() => { props.setModalVisible(false) }}>
                        <RollbackOutlined style={{ fontSize: '16px', fontWeight: '1900', color: '#08c' }} />
                        {langValue == 0 ? '返回Return' : (langValue == 1 ? '返回' : 'Return')}
                    </Button>
                </div>
            </div>
        </div >
    )
}
